import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";
import Homepage from "./pages/Homepage";
import Step1 from "./pages/Step1";
import Step2 from "./pages/Step2";
import Step3 from "./pages/Step3";
import CreateAccount from "./pages/CreateAccount";
import Login from "./pages/Login";
import Class from "./pages/Class";
import OurProducts from "./pages/OurProducts";
import LiveOnlineClasses from "./pages/LiveOnlineClasses";
import AboutUs from "./pages/AboutUs";
import SMSPlatform from "./pages/SMSPlatform";
import { useEffect } from "react";

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    //TODO: Update meta titles and descriptions below
    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
      case "/step1":
        title = "";
        metaDescription = "";
        break;
      case "/step2":
        title = "";
        metaDescription = "";
        break;
      case "/step3":
        title = "";
        metaDescription = "";
        break;
      case "/create-account":
        title = "";
        metaDescription = "";
        break;
      case "/login":
        title = "";
        metaDescription = "";
        break;
      case "/class":
        title = "";
        metaDescription = "";
        break;
      case "/our-products":
        title = "";
        metaDescription = "";
        break;
      case "/live-online-classes":
        title = "";
        metaDescription = "";
        break;
      case "/aboutus":
        title = "";
        metaDescription = "";
        break;
      case "/sms-platform":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Homepage />} />

      <Route path="/step1" element={<Step1 />} />

      <Route path="/step2" element={<Step2 />} />

      <Route path="/step3" element={<Step3 />} />

      <Route path="/create-account" element={<CreateAccount />} />

      <Route path="/login" element={<Login />} />

      <Route path="/class" element={<Class />} />

      <Route path="/our-products" element={<OurProducts />} />

      <Route path="/live-online-classes" element={<LiveOnlineClasses />} />

      <Route path="/aboutus" element={<AboutUs />} />

      <Route path="/sms-platform" element={<SMSPlatform />} />
    </Routes>
  );
}
export default App;
